import {Component, OnInit} from '@angular/core';
import {MemberModel} from '../../models/user.model';
import {MemberService} from '../../services/member.service';
import {MenuModel} from "../../models/menu.model";

@Component({
    selector: 'app-index',
    templateUrl: './index.component.html',
    styleUrl: './index.component.scss'
})
export class IndexComponent implements OnInit {
    public TAB_ITEMS = {
        MENU_CONTRACTS: 'MENU_CONTRACTS',
        MENU_DOCS: 'MENU_DOCS',
        MENU_TASKS: 'MENU_TASKS',
        MENU_FINANCE: 'MENU_FINANCE',
        MENU_PRODUCTION: 'MENU_PRODUCTION',
        MENU_USERS: 'MENU_USERS',
    }

    currentMember: MemberModel;
    currentMenu: MenuModel[] = [];

    tab: number;

    constructor(
        private memberService: MemberService,
    ) {
    }

    ngOnInit(): void {
        this.memberService.getCurrentMember().then(res => {
            this.currentMember = res;
        });
        this.memberService.getMenu().subscribe(res => {
            this.currentMenu = res.project_settings;
            let index = 0;

            for (const item in this.TAB_ITEMS) {
                if (this.isShowTab(item)) {
                    this.tab = index;
                    break;
                }
                if (item === this.TAB_ITEMS.MENU_TASKS) {
                    index += 2
                } else {
                    index++;
                }
            }
        })
    }

    changeTab(index: number) {
        this.tab = index;
    }

    isShowTab(tabKey: string) {
        for (const item of this.currentMenu) {
            if (item.menu_key === tabKey) {
                return true;
            }
        }
        return false;
    }

}
